import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { nextStep } from '../../state/actions/step';
import { updateCurrentAnswer, updateResults, updateSaveState } from '../../state/actions/results';
import { getFinishQuestionnaireUrl } from '../../state/actions/report';
import { logout } from '../../state/actions/auth';
import { closeModal, setModalDelay } from '../../state/actions/modal';
import { activateFleetParade } from '../../state/actions/fleet-parade';
import { buildCleanAvatarOptions, initConfetti, redirectToNeon } from '../../helpers';
import ResultState from "../../constants/ResultState";
import Logger from "../../tools/logger";

export default function HOCNextStepController (WrappedComponent) {

	@connect(
		state => ({
			nextStepData: state.step.steps[Math.min(state.step.steps.length - 1, state.step.activeIndex + 1)],
			answer: state.results.answer,
			results: state.results,
			saveState: state.results.saveState,
			tempState: state.results,
			activeStep: state.step.activeStep.id,
			report: state.report,
			auth: state.auth
		}),
		dispatch => {
			return ({
				nextStepDispatch: () => {
					dispatch(nextStep());
				},
				updateCurrentAnswer: (answer) => {
					dispatch(updateCurrentAnswer(answer));
				},
				updateResults: async (results) => {
                    dispatch(updateResults(results));
				},
				updateSaveState: (saveData) => {
					dispatch(updateSaveState(saveData));
				},
				setModalDelay: (bool) => {
					dispatch(setModalDelay(bool));
				},
				closeModal: () => {
					dispatch(closeModal());
				},
				activateFleetParade: () => {
					dispatch(activateFleetParade());
				},
				getFinishQuestionnaireUrl: () => {
                    dispatch(getFinishQuestionnaireUrl());
				},
				logout: () => {
                    dispatch(logout());
				}
			})
		}
	)
	class HOC extends Component {

		static propTypes = {
			nextStepData: PropTypes.object,
			answer: PropTypes.object,
			saveStatePlayers: PropTypes.object,
			tempStatePlayers: PropTypes.object,
			nextStep: PropTypes.func,
			updateResults: PropTypes.func,
			setModalDelay: PropTypes.func,
			closeModal: PropTypes.func,
			getFinishQuestionnaireUrl: PropTypes.func,
			logout: PropTypes.func
		};

		constructor (props) {
			super(props);

			this.buttonText = props.window.current.buttonText[props.countryCode];
		}

		/**
		 * @description
		 * This method checks the temporary answers store and applies the correct
		 * updates to the store.
		 *
		 */
		applyUpdates () {
			const updates = {
				currentStep: this.props.nextStepData.id
			};

			// This logger call is meant to track various state objects in the issue of missing answers
			// During the research it turned out that the active step was updated before the current window
			// which could result in being able to click "continue" again, in this same window
			// and get another step ahead (skipping) because of the activeStep being plussed again.
			Logger.instance.notice({
				message: `applyUpdates called for activeStep: ${this.props.activeStep}, window: ${this.props.window.current.heading['EN']}, with answers: ${JSON.stringify(this.props.answer)}`,
				component: 'next-step'
			});

			if (this.props.answer) {
				updates['answers'] = this.props.answer;
				updates['answers'][this.props.activeStep].timeEnd = Date.now();
			}

			if (
				(this.props.answer && this.props.hasResources) ||
				(this.props.window.current.playerBaseResources) ||
				(this.props.answer && this.props.hasRewards)
			) {
				this.props.setModalDelay(true);
				updates['players'] = this.updateSaveState();
			}

			if (this.props.answer && this.props.hasAvatar) {
				const saveState = this.props.saveState.avatar && this.props.saveState.avatar.options || [];
				const tempState = this.props.tempState.avatar && this.props.tempState.avatar.options || [];
				const genderTempState = this.props.tempState.avatar && this.props.tempState.avatar.gender || '';
				const genderSaveState = this.props.saveState.avatar && this.props.saveState.avatar.gender || '';
				updates['avatar'] = {
					options: buildCleanAvatarOptions([...saveState, ...tempState]),
					gender: genderSaveState || genderTempState
				};
			}

			if (this.props.isLastQuestion) {
				updates['finishedOn'] = Date.now();
			}

			this.updateAnswers(updates);

			this.nextStep();
		}

		componentDidMount() {
			this.setState({
				handleClick: () => this.handleClick(),
				isNextStepDisabled: this.props.window.isNextStepDisabled,
				activeStep: this.props.activeStep
			});

            if (this.props.results.resultsState === ResultState.UPDATE_ERROR) {
                document.querySelector('#modal_connection_error').style.display='block';
            }
        }

		componentDidUpdate(prevProps) {
		    if (this.props.results.resultsState === ResultState.UPDATE_ERROR) {
				document.querySelector('#modal_connection_error').style.display = 'block';
			}

		    // check if the report is available and we should redirec to it
			// for user experience, redirect with a timeout
			if (this.props.report.shouldRedirect && this.props.report.url) {

				// check if logout call was successful
				if (this.props.auth.loggedOut) {
					return redirectToNeon(this.props.report.url);
				} else {

					// call api to redirect to the report
					this.redirectTimeout = window.setTimeout(() => {
						this.props.logout();
					}, 3000);
				}
			}

			// update the next button state when the state was changed in the props (new question or section)
			// or when the index of the current window has changed (next screen within a section)
		    if (prevProps.window.isNextStepDisabled !== this.props.window.isNextStepDisabled
				|| prevProps.window.index !== this.props.window.index) {
		    	this.setState({
					isNextStepDisabled: this.props.window.isNextStepDisabled
				});
			}
		}

		updateAnswers(updates) {
		    this.props.updateResults(updates);

			// Todo: get actions to work with a promise returned (or only dispatch actions when api call succeeded)
			// console.log('update results ', this.props);
			// this.props.updateResults(updates).then((action) => {
			// 	console.log('update result ', action);
			// }).catch(error => {
			// 	console.log('update result error');
			//
			// 	let retries = 1;
			//
			// 	if (this.state.saveResultRetries === 3) {
			// 		return redirectToNeon();
			// 	}
			//
			// 	if (this.state.saveResultRetries) {
			// 		retries += this.state.saveResultRetries;
			// 	}
			//
			// 	this.setState({
			// 		saveResultRetries: retries
			// 	});
			//
			// 	console.log('call update answers again');
			// 	debugger;
			// 	// this.updateAnswers(updates);
			// });
		}

		/**
		 * @description
		 * Resets the temp stores and then moves to the next step
		 *
		 */
		nextStep () {
			this.props.updateCurrentAnswer(null);
			// this.props.updateSaveState(null);
			this.props.nextStepDispatch();
		}

		/**
		 * @description
		 * Handles the button click to either go to the next window or post answers
		 *
		 */
		handleClick () {
			Logger.instance.notice({
				message: 'handleClick called',
				component: 'next-step'
			});

			// don't proceed if the button should be disabled
			if (this.state.isNextStepDisabled) {
				return;
			}

			// after clicking the submit button, always disable the button
			// it will automatically be shown in componentWillMount, at the next question
			this.setState({
				isNextStepDisabled: true
			});

			// @TODO Make a cleaner solution to reset the scrollbar of the modal.
			document.querySelector('.modal').scrollTop = 0;

			if (this.props.isLastStep && this.props.window.isLast) {
				this.props.closeModal();
				this.props.activateFleetParade();
				initConfetti();

				// call api to redirect to the report
				this.props.getFinishQuestionnaireUrl();

			} else if (this.props.window.isLast) {
				this.applyUpdates();
			} else {
				this.props.nextWindow();
			}
		}

		/**
		 * @description
		 * Applies the temp resources to the current saved resources to make a combined
		 * state ready to post to the store
		 *
		 * @returns {object}
		 */
		updateSaveState () {
			let combinedState = {};

			for (const [key, value] of Object.entries(this.props.saveState.players)) {
				const rewards = value.rewards || [];
				const playerResources = this.props.tempState.players[key].resources;
				const playerRewards = this.props.tempState.players[key].rewards;

				const combineResources = playerResources ? value.resources + playerResources : value.resources;
				const combineRewards = playerRewards ? [...playerRewards, ...rewards] : rewards;

				combinedState[key] = {
					resources: combineResources,
					rewards: combineRewards
				}
			}

			return combinedState;
		}

		/**
		 * @description
		 * Component Method
		 * Renders a component
		 *
		 * @returns {ReactElement} component
		 */
		render () {
			return (
				<WrappedComponent {...this.state} >
					{this.buttonText}
				</WrappedComponent>
			)
		}
	}

	return HOC;
}
